__turbopack_context__.v({
  "container": "Navigation-module-scss-module__X21Pya__container",
  "list": "Navigation-module-scss-module__X21Pya__list",
  "listItem": "Navigation-module-scss-module__X21Pya__listItem",
  "pills": "Navigation-module-scss-module__X21Pya__pills",
  "topics": "Navigation-module-scss-module__X21Pya__topics",
});
